import { useParams } from "react-router-dom";
import AddEmailTemplate from "./AddEmailTemplate";

export default function EditEmailTemplate() {
  const { id } = useParams<{ id: string }>();
  return <AddEmailTemplate isEdit templateId={id} />;
}
